import { t as SystemStatus } from "./status-ChiHYKYc.mjs";

//#region src/types/config.ts
/**
* Log levels for the logger
* - DEBUG: Show all logs (debug, info, warn, error)
* - INFO: Show info, warn, and error logs
* - WARN: Show warn and error logs
* - ERROR: Show only error logs
* - NONE: Don't show any logs
*/
let LogLevel = /* @__PURE__ */ function(LogLevel$1) {
	LogLevel$1[LogLevel$1["DEBUG"] = 0] = "DEBUG";
	LogLevel$1[LogLevel$1["INFO"] = 1] = "INFO";
	LogLevel$1[LogLevel$1["WARN"] = 2] = "WARN";
	LogLevel$1[LogLevel$1["ERROR"] = 3] = "ERROR";
	LogLevel$1[LogLevel$1["NONE"] = 4] = "NONE";
	return LogLevel$1;
}({});
/**
* Default configuration values
*/
const DEFAULT_CONFIG = {
	alertComponent: void 0,
	i18nProvider: void 0,
	interceptors: [],
	displayIncidentDetails: false,
	placement: "top-right",
	logLevel: LogLevel.NONE,
	mobile: {
		enabled: false,
		placement: "top",
		mediaQuery: "(max-width: 768px)"
	},
	alertClosureBehavior: {
		[SystemStatus.Operational]: {
			closeDurationMs: 0,
			checkIntervalMs: 0
		},
		[SystemStatus.UnderMaintenance]: {
			closeDurationMs: 0,
			checkIntervalMs: 3e5
		},
		[SystemStatus.DegradedPerformance]: {
			closeDurationMs: 3e5,
			checkIntervalMs: 6e4
		},
		[SystemStatus.PartialOutage]: {
			closeDurationMs: 3e5,
			checkIntervalMs: 6e4
		},
		[SystemStatus.MajorOutage]: {
			closeDurationMs: 3e5,
			checkIntervalMs: 6e4
		}
	},
	containerElement: void 0,
	statusCheckTimeoutMs: 1e4,
	useSandboxedFetch: true
};

//#endregion
//#region src/utils/logger.ts
/**
* Logger utility that controls logging based on log level
* This prevents unnecessary logs from appearing in production environments
*/
var Logger = class Logger {
	static instance;
	logLevel = LogLevel.NONE;
	prefix = "[OopsWidget]";
	constructor() {}
	/**
	* Get the singleton instance of the logger
	*/
	static getInstance() {
		if (!Logger.instance) Logger.instance = new Logger();
		return Logger.instance;
	}
	/**
	* Configure the logger
	* @param config Configuration options
	*/
	configure(config) {
		if (config.logLevel !== void 0) this.logLevel = config.logLevel;
	}
	/**
	* Log a message (only if log level allows)
	* @param args Arguments to log
	*/
	log(...args) {
		this.debug(...args);
	}
	/**
	* Log an info message (only if log level allows)
	* @param args Arguments to log
	*/
	info(...args) {
		if (this.logLevel <= LogLevel.INFO) console.info(this.prefix, ...args);
	}
	/**
	* Log a warning message (only if log level allows)
	* @param args Arguments to log
	*/
	warn(...args) {
		if (this.logLevel <= LogLevel.WARN) console.warn(this.prefix, ...args);
	}
	/**
	* Log an error message (only if log level allows)
	* @param args Arguments to log
	*/
	error(...args) {
		if (this.logLevel <= LogLevel.ERROR) console.error(this.prefix, ...args);
	}
	/**
	* Log a debug message (only if log level allows)
	* @param args Arguments to log
	*/
	debug(...args) {
		if (this.logLevel <= LogLevel.DEBUG) console.debug(this.prefix, ...args);
	}
};
/**
* Convenience function to get the logger instance
* @returns Logger instance
*/
const getLogger = () => Logger.getInstance();

//#endregion
export { DEFAULT_CONFIG as n, LogLevel as r, getLogger as t };